import { render, staticRenderFns } from "./CusEdit.vue?vue&type=template&id=023d3b56&scoped=true&"
import script from "./CusEdit.vue?vue&type=script&lang=js&"
export * from "./CusEdit.vue?vue&type=script&lang=js&"
import style0 from "./CusEdit.vue?vue&type=style&index=0&id=023d3b56&lang=less&scoped=true&"
import style1 from "./CusEdit.vue?vue&type=style&index=1&id=023d3b56&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023d3b56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('023d3b56')) {
      api.createRecord('023d3b56', component.options)
    } else {
      api.reload('023d3b56', component.options)
    }
    module.hot.accept("./CusEdit.vue?vue&type=template&id=023d3b56&scoped=true&", function () {
      api.rerender('023d3b56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/music/comp/Lesson/CusEdit.vue"
export default component.exports